export const PlayerModuleIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2C6.30381 2 5.63613 2.27656 5.14384 2.76884C4.65156 3.26113 4.375 3.92881 4.375 4.625C4.375 5.32119 4.65156 5.98887 5.14384 6.48116C5.63613 6.97344 6.30381 7.25 7 7.25C7.69619 7.25 8.36387 6.97344 8.85616 6.48116C9.34844 5.98887 9.625 5.32119 9.625 4.625C9.625 3.92881 9.34844 3.26113 8.85616 2.76884C8.36387 2.27656 7.69619 2 7 2ZM2.875 4.625C2.875 3.53098 3.3096 2.48177 4.08318 1.70818C4.85677 0.934597 5.90598 0.5 7 0.5C8.09402 0.5 9.14323 0.934597 9.91682 1.70818C10.6904 2.48177 11.125 3.53098 11.125 4.625C11.125 5.71902 10.6904 6.76823 9.91682 7.54182C9.14323 8.3154 8.09402 8.75 7 8.75C5.90598 8.75 4.85677 8.3154 4.08318 7.54182C3.3096 6.76823 2.875 5.71902 2.875 4.625ZM0.25 13.25C0.25 12.2554 0.645088 11.3016 1.34835 10.5983C2.05161 9.89509 3.00544 9.5 4 9.5H10C10.9946 9.5 11.9484 9.89509 12.6517 10.5983C13.3549 11.3016 13.75 12.2554 13.75 13.25V15.5H0.25V13.25ZM4 11C3.40326 11 2.83097 11.2371 2.40901 11.659C1.98705 12.081 1.75 12.6533 1.75 13.25V14H12.25V13.25C12.25 12.6533 12.0129 12.081 11.591 11.659C11.169 11.2371 10.5967 11 10 11H4Z"
        fill="white"
      />
    </svg>
  );
};

export default PlayerModuleIcon;
